module.exports = __webpack_public_path__ + "img/ic_spo2_level@2x.7e0ba168.png";